module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona-tour-d4e0abca13ae567c93ed4eac16a76029.jpg";